import axios from 'axios';

/**
 * 获取数据跳变修正记录
 */
// eslint-disable-next-line import/prefer-default-export
export const getDataJumps = (params) => {
  const { deviceName, startTime, endTime, nodeName } = params;
  return axios.get(`/api/data-jump/history/${deviceName}`, {
    params: {
      startTime,
      endTime,
      nodeName,
    },
  });
};

/**
 * 近线端管口修正记录
 */
export const getTopshifts = (params) => {
  const { deviceId } = params;
  return axios.get(`/api/topshifts/devices/${deviceId}`);
};

export const deleteTopshift = (params) => {
  const { topshiftId } = params;
  return axios.delete(`/api/topshifts/${topshiftId}`);
};

export const createTopshift = (params) => {
  const { deviceId, startAt, correctX, correctY, correctZ } = params;
  return axios.post(`/api/topshifts/devices/${deviceId}`, {
    startAt, correctX, correctY, correctZ,
  });
};

